module.exports = __webpack_public_path__ + "static/media/icon_168.e7eb6e85.svg";